import {ensureHeadersCreated} from "./RequestUtils";

export function getCsrfToken(): string | undefined {
    return (document?.querySelector(".csrf-token") as HTMLElement)?.dataset?.csrfToken;
}

export function injectCsrfInputElement(formEl: HTMLElement) {
    const csrfToken = getCsrfToken();
    if (csrfToken && formEl) {
        const input = document.createElement("input");
        input.classList.add("csrf-token");
        input.type = "hidden";
        input.name = "xsrf";
        input.dataset.csrfToken = csrfToken;
        input.value = csrfToken;
        formEl.append(input);
    }
}

export function methodRequiresCsrfToken(method?: string | null): boolean {
    return !method || method === "POST" || method === "PUT" || method === "DELETE" || method === "PATCH";
}

export function addCsrfTokenToXhr(
    xhr: Pick<XMLHttpRequest, "setRequestHeader">,
    method?: string,
) {
    if (xhr && methodRequiresCsrfToken(method)) {
        const csrfToken = getCsrfToken();
        if (csrfToken) {
            xhr.setRequestHeader("X-CSRFToken", csrfToken);
        }
    }
}

export function addCsrfTokenToRequestOptions(options?: RequestInit | null) {
    if (options && methodRequiresCsrfToken(options.method)) {
        const csrfToken = getCsrfToken();
        if (csrfToken) {
            ensureHeadersCreated(options);
            (options.headers as Headers).append("X-CSRFToken", csrfToken);
        }
    }
}
